import { Icon } from '@aibees/shared/components';
import { classnames } from '@aibees/shared/utils';
import { Box } from '@mui/material';
import { memo } from 'react';
import {
  useAdvanceTableConfigContext,
  useAdvanceTableDataContext,
  useAdvanceTableStickyContext,
} from '../../context';
import * as Styled from './styles';
import * as SX from './sx';
import type { CollapseProps as Props } from './types';

export const Collapse = memo(({ className }: Props) => {
  const { config } = useAdvanceTableConfigContext();
  const { browseData } = useAdvanceTableDataContext();
  const { stickyCollapsed, setStickyCollapsed, stickyRowsHeight } =
    useAdvanceTableStickyContext();
  const { data, isLoading } = browseData;

  const top = stickyCollapsed ? 43 : stickyRowsHeight + 57;
  const handleToggle = () => setStickyCollapsed(!stickyCollapsed);

  const iconName = stickyCollapsed ? 'chevron-down' : 'chevron-up';
  const current = data?.top?.length;
  const max = config.maxStickyRows;

  if (isLoading || !(data?.top && data?.top?.length > 0)) return null;

  const lessThanTwoTop = data?.top.length < 1;

  return (
    <Styled.Wrapper
      className={classnames('Collapse', className, { lessThanTwoTop })}
      sx={{
        ...SX.root(top),
        transform: stickyCollapsed ? `translateY(${44}px)` : `translateY(0px)`,
      }}
    >
      {current && current > 1 && (
        <Box sx={SX.container} onClick={handleToggle}>
          {current}/{max}
          <Icon name={iconName} sxx={SX.icon} size={14} />
        </Box>
      )}
    </Styled.Wrapper>
  );
});

Collapse.displayName = 'Collapse';
